const MEMBER_ATTESTATIONS_FULL_QUERY = `
  memberIdentifier
  requestingCoverageIndicator
  terminateCoverageStartMedicareIndicator
  demographic {
    ssn
    birthDate
    name {
      firstName
      middleName
      lastName
      suffix
    }
    ssnAlternateName {
      firstName
      middleName
      lastName
      suffix
    }
    sex
    sexAssignedAtBirth
    sexAssignedAtBirthOtherText
    gender
    genderDifferentTermText
    sexualOrientation
    sexualOrientationDifferentTermText
    maritalStatus
    noHomeAddressIndicator
    liveOutsideStateTemporarilyIndicator
    hispanicOriginIndicator
    americanIndianAlaskanNativeIndicator
    ethnicity
    otherEthnicityText
    race
    otherRaceText
    homeAddress {
      streetName1
      streetName2
      cityName
      stateCode
      plus4Code
      zipCode
      countyName
      countyFipsCode
    }
    mailingAddress {
      streetName1
      streetName2
      cityName
      stateCode
      plus4Code
      zipCode
      countyName
      countyFipsCode
    }
    transientAddress {
      streetName1
      streetName2
      cityName
      stateCode
      plus4Code
      zipCode
      countyName
      countyFipsCode
    }
  }
  income {
    annualTaxIncome {
      incomeAmount
      incomeLessExplainedIndicator
      unknownIncomeIndicator
      variableIncomeIndicator
      variableIncomeDescriptionText
      taxHouseholdIncomeDiscrepancyDescriptionText
      receivedUnemploymentCompensationIndicator
      taxHouseholdIncomeDifferenceReasonType
    }
    currentIncome
  }
  other {
    appliedDuringOeOrLifeChangeIndicator
    changeInCircumstance {
      GAINING_LAWFUL_PRESENCE {
        changeDate
      }
      RELEASE_FROM_INCARCERATION {
        changeDate
      }
      LOSS_OF_MEC {
        changeDate
        lossMecIssuerName
      }
      FUTURE_LOSS_OF_MEC {
        changeDate
        lossMecIssuerName
      }
      RELOCATION {
        changeDate
        movedFromForeignCountryIndicator
        coverage60DayBeforeMoveIndicator
        precedingZipCode
        precedingStateCode
        precedingCountyName
      }
      MARRIAGE {
        changeDate
        coverage60DayBeforeMarriageIndicator
        liveInForeignCountry60DayBeforeMarriageIndicator
      }
      ADOPTION {
        changeDate
      }
    }
    americanIndianAlaskanNative {
      federallyRecognizedTribeName
      personRecognizedTribeIndicator
      receiveItuIndicator
      eligibleForItuIndicator
    }
    veteranIndicator
    incarcerationType
    reconcilePtcIndicatorType
    veteranSelfIndicator
    nonMemberVeteranRelationshipTypes
  }
  nonMagi {
    blindOrDisabledIndicator
    longTermCareIndicator
  }
  medicaid {
    medicaidDeniedDate
    medicaidDeniedDueToImmigrationIndicator
    medicaidDeniedIndicator
    parent1WeeklyWorkHourQuantity
    parent2WeeklyWorkHourQuantity
    unpaidBillIndicator
    coveredDependentChildIndicator
    enrolledInHealthCoverageIndicator
    insuranceCoverage {
      insurancePolicyMemberId
      insurancePolicyNumber
      insurancePlanName
      insuranceMarketType
    }
    informationChangeSinceMedicaidDeniedIndicator
    immigrationStatusFiveYearIndicator
    immigrationStatusChangeSinceDeniedIndicator
    informationChangeSinceMedicaidEndedIndicator
    medicaidEndIndicator
    medicaidEndDate
  }
  lawfulPresence {
    lawfulPresenceGrantDate
    lawfulPresenceStatusIndicator
    livedInUs5yearIndicator
    noAlienNumberIndicator
    citizenshipIndicator
    naturalizedCitizenIndicator
    lawfulPresenceDocumentation {
      PERMANENT_RESIDENT_CARD_I_551 {
        documentExpirationDate
        alienNumber
        employmentAuthorizationCategoryIdentifier
        sevisId
        i94Number
        passportNumber
        passportIssuingCountry
        cardNumber
        naturalizationCertificateNumber
        citizenshipNumber
        documentAlternateName {
          firstName
          middleName
          lastName
          suffix
        }
        noIdentifiersProvidedIndicator
        otherTypeText
      }
      TEMPORARY_I_551_STAMP_ON_PASSPORT_OR_I_94_I_94A {
        documentExpirationDate
        alienNumber
        employmentAuthorizationCategoryIdentifier
        sevisId
        i94Number
        passportNumber
        passportIssuingCountry
        cardNumber
        naturalizationCertificateNumber
        citizenshipNumber
        documentAlternateName {
          firstName
          middleName
          lastName
          suffix
        }
        noIdentifiersProvidedIndicator
        otherTypeText
      }
      MACHINE_READABLE_IMMIGRANT_VISA_WITH_TEMPORARY_I_551_LANGUAGE {
        documentExpirationDate
        alienNumber
        employmentAuthorizationCategoryIdentifier
        sevisId
        i94Number
        passportNumber
        passportIssuingCountry
        cardNumber
        naturalizationCertificateNumber
        citizenshipNumber
        documentAlternateName {
          firstName
          middleName
          lastName
          suffix
        }
        noIdentifiersProvidedIndicator
        otherTypeText
      }
      EMPLOYMENT_AUTHORIZATION_CARD_I_766 {
        documentExpirationDate
        alienNumber
        employmentAuthorizationCategoryIdentifier
        sevisId
        i94Number
        passportNumber
        passportIssuingCountry
        cardNumber
        naturalizationCertificateNumber
        citizenshipNumber
        documentAlternateName {
          firstName
          middleName
          lastName
          suffix
        }
        noIdentifiersProvidedIndicator
        otherTypeText
      }
      ARRIVAL_DEPARTURE_RECORD_IN_FOREIGN_PASSPORT_I_94 {
        documentExpirationDate
        alienNumber
        employmentAuthorizationCategoryIdentifier
        sevisId
        i94Number
        passportNumber
        passportIssuingCountry
        cardNumber
        naturalizationCertificateNumber
        citizenshipNumber
        documentAlternateName {
          firstName
          middleName
          lastName
          suffix
        }
        noIdentifiersProvidedIndicator
        otherTypeText
      }
      ARRIVAL_DEPARTURE_RECORD_IN_UNEXPIRED_FOREIGN_PASSPORT_I_94 {
        documentExpirationDate
        alienNumber
        employmentAuthorizationCategoryIdentifier
        sevisId
        i94Number
        passportNumber
        passportIssuingCountry
        cardNumber
        naturalizationCertificateNumber
        citizenshipNumber
        documentAlternateName {
          firstName
          middleName
          lastName
          suffix
        }
        noIdentifiersProvidedIndicator
        otherTypeText
      }
      FOREIGN_PASSPORT {
        documentExpirationDate
        alienNumber
        employmentAuthorizationCategoryIdentifier
        sevisId
        i94Number
        passportNumber
        passportIssuingCountry
        cardNumber
        naturalizationCertificateNumber
        citizenshipNumber
        documentAlternateName {
          firstName
          middleName
          lastName
          suffix
        }
        noIdentifiersProvidedIndicator
        otherTypeText
      }
      REENTRY_PERMIT {
        documentExpirationDate
        alienNumber
        employmentAuthorizationCategoryIdentifier
        sevisId
        i94Number
        passportNumber
        passportIssuingCountry
        cardNumber
        naturalizationCertificateNumber
        citizenshipNumber
        documentAlternateName {
          firstName
          middleName
          lastName
          suffix
        }
        noIdentifiersProvidedIndicator
        otherTypeText
      }
      REFUGEE_TRAVEL_DOCUMENT {
        documentExpirationDate
        alienNumber
        employmentAuthorizationCategoryIdentifier
        sevisId
        i94Number
        passportNumber
        passportIssuingCountry
        cardNumber
        naturalizationCertificateNumber
        citizenshipNumber
        documentAlternateName {
          firstName
          middleName
          lastName
          suffix
        }
        noIdentifiersProvidedIndicator
        otherTypeText
      }
      CERTIFICATE_OF_ELIGIBILITY_FOR_NONIMMIGRANT_STUDENT_STATUS_I_20 {
        documentExpirationDate
        alienNumber
        employmentAuthorizationCategoryIdentifier
        sevisId
        i94Number
        passportNumber
        passportIssuingCountry
        cardNumber
        naturalizationCertificateNumber
        citizenshipNumber
        documentAlternateName {
          firstName
          middleName
          lastName
          suffix
        }
        noIdentifiersProvidedIndicator
        otherTypeText
      }
      CERTIFICATE_OF_ELIGIBILITY_FOR_EXCHANGE_VISITOR_STATUS_DS_2019 {
        documentExpirationDate
        alienNumber
        employmentAuthorizationCategoryIdentifier
        sevisId
        i94Number
        passportNumber
        passportIssuingCountry
        cardNumber
        naturalizationCertificateNumber
        citizenshipNumber
        documentAlternateName {
          firstName
          middleName
          lastName
          suffix
        }
        noIdentifiersProvidedIndicator
        otherTypeText
      }
      NOTICE_OF_ACTION_I_797 {
        documentExpirationDate
        alienNumber
        employmentAuthorizationCategoryIdentifier
        sevisId
        i94Number
        passportNumber
        passportIssuingCountry
        cardNumber
        naturalizationCertificateNumber
        citizenshipNumber
        documentAlternateName {
          firstName
          middleName
          lastName
          suffix
        }
        noIdentifiersProvidedIndicator
        otherTypeText
      }
      DOCUMENT_INDICATING_A_MEMBER_OF_RECOGNIZED_INDIAN_TRIBE_OR_INDIAN_BORN_IN_CANADA {
        documentExpirationDate
        alienNumber
        employmentAuthorizationCategoryIdentifier
        sevisId
        i94Number
        passportNumber
        passportIssuingCountry
        cardNumber
        naturalizationCertificateNumber
        citizenshipNumber
        documentAlternateName {
          firstName
          middleName
          lastName
          suffix
        }
        noIdentifiersProvidedIndicator
        otherTypeText
      }
      CERTIFICATION_FROM_HHS_ORR {
        documentExpirationDate
        alienNumber
        employmentAuthorizationCategoryIdentifier
        sevisId
        i94Number
        passportNumber
        passportIssuingCountry
        cardNumber
        naturalizationCertificateNumber
        citizenshipNumber
        documentAlternateName {
          firstName
          middleName
          lastName
          suffix
        }
        noIdentifiersProvidedIndicator
        otherTypeText
      }
      ORR_ELIGIBILITY_LETTER {
        documentExpirationDate
        alienNumber
        employmentAuthorizationCategoryIdentifier
        sevisId
        i94Number
        passportNumber
        passportIssuingCountry
        cardNumber
        naturalizationCertificateNumber
        citizenshipNumber
        documentAlternateName {
          firstName
          middleName
          lastName
          suffix
        }
        noIdentifiersProvidedIndicator
        otherTypeText
      }
      CUBAN_HAITAN_ENTRANT {
        documentExpirationDate
        alienNumber
        employmentAuthorizationCategoryIdentifier
        sevisId
        i94Number
        passportNumber
        passportIssuingCountry
        cardNumber
        naturalizationCertificateNumber
        citizenshipNumber
        documentAlternateName {
          firstName
          middleName
          lastName
          suffix
        }
        noIdentifiersProvidedIndicator
        otherTypeText
      }
      DOCUMENT_INDICATING_WITHHOLDING_OF_REMOVAL {
        documentExpirationDate
        alienNumber
        employmentAuthorizationCategoryIdentifier
        sevisId
        i94Number
        passportNumber
        passportIssuingCountry
        cardNumber
        naturalizationCertificateNumber
        citizenshipNumber
        documentAlternateName {
          firstName
          middleName
          lastName
          suffix
        }
        noIdentifiersProvidedIndicator
        otherTypeText
      }
      RESIDENT_OF_AMERICAN_SAMOA_CARD {
        documentExpirationDate
        alienNumber
        employmentAuthorizationCategoryIdentifier
        sevisId
        i94Number
        passportNumber
        passportIssuingCountry
        cardNumber
        naturalizationCertificateNumber
        citizenshipNumber
        documentAlternateName {
          firstName
          middleName
          lastName
          suffix
        }
        noIdentifiersProvidedIndicator
        otherTypeText
      }
      ADMINISTRATIVE_STAY_BY_DHS {
        documentExpirationDate
        alienNumber
        employmentAuthorizationCategoryIdentifier
        sevisId
        i94Number
        passportNumber
        passportIssuingCountry
        cardNumber
        naturalizationCertificateNumber
        citizenshipNumber
        documentAlternateName {
          firstName
          middleName
          lastName
          suffix
        }
        noIdentifiersProvidedIndicator
        otherTypeText
      }
      OTHER {
        documentExpirationDate
        alienNumber
        employmentAuthorizationCategoryIdentifier
        sevisId
        i94Number
        passportNumber
        passportIssuingCountry
        cardNumber
        naturalizationCertificateNumber
        citizenshipNumber
        documentAlternateName {
          firstName
          middleName
          lastName
          suffix
        }
        noIdentifiersProvidedIndicator
        otherTypeText
      }
      CERTIFICATE_OF_CITIZENSHIP {
        documentExpirationDate
        alienNumber
        employmentAuthorizationCategoryIdentifier
        sevisId
        i94Number
        passportNumber
        passportIssuingCountry
        cardNumber
        naturalizationCertificateNumber
        citizenshipNumber
        documentAlternateName {
          firstName
          middleName
          lastName
          suffix
        }
        noIdentifiersProvidedIndicator
        otherTypeText
      }
      CERTIFICATE_OF_NATURALIZATION {
        documentExpirationDate
        alienNumber
        employmentAuthorizationCategoryIdentifier
        sevisId
        i94Number
        passportNumber
        passportIssuingCountry
        cardNumber
        naturalizationCertificateNumber
        citizenshipNumber
        documentAlternateName {
          firstName
          middleName
          lastName
          suffix
        }
        noIdentifiersProvidedIndicator
        otherTypeText
      }
      NS1_MEMBERS_OF_A_FEDERALLY_RECOGNIZED_INDIAN_TRIBE {
        documentExpirationDate
        alienNumber
        employmentAuthorizationCategoryIdentifier
        sevisId
        i94Number
        passportNumber
        passportIssuingCountry
        cardNumber
        naturalizationCertificateNumber
        citizenshipNumber
        documentAlternateName {
          firstName
          middleName
          lastName
          suffix
        }
        noIdentifiersProvidedIndicator
        otherTypeText
      }
      NS2_NON_CITIZEN_WHO_IS_LAWFULLY_PRESENT_IN_AMERICAN_SAMOA_UNDER_THE_IMMIGRATION_LAWS_OF_AMERICAN_SAMOA {
        documentExpirationDate
        alienNumber
        employmentAuthorizationCategoryIdentifier
        sevisId
        i94Number
        passportNumber
        passportIssuingCountry
        cardNumber
        naturalizationCertificateNumber
        citizenshipNumber
        documentAlternateName {
          firstName
          middleName
          lastName
          suffix
        }
        noIdentifiersProvidedIndicator
        otherTypeText
      }
      NS4_NON_CITIZEN_WHO_IS_LAWFULLY_PRESENT_IN_AMERICAN_SAMOA {
        documentExpirationDate
        alienNumber
        employmentAuthorizationCategoryIdentifier
        sevisId
        i94Number
        passportNumber
        passportIssuingCountry
        cardNumber
        naturalizationCertificateNumber
        citizenshipNumber
        documentAlternateName {
          firstName
          middleName
          lastName
          suffix
        }
        noIdentifiersProvidedIndicator
        otherTypeText
      }
      VAWA_SELF_PETITIONER {
        documentExpirationDate
        alienNumber
        employmentAuthorizationCategoryIdentifier
        sevisId
        i94Number
        passportNumber
        passportIssuingCountry
        cardNumber
        naturalizationCertificateNumber
        citizenshipNumber
        documentAlternateName {
          firstName
          middleName
          lastName
          suffix
        }
        noIdentifiersProvidedIndicator
        otherTypeText
      }
    }
  }
  family {
    liveWithParentOrSiblingIndicator
    babyDueQuantity
    taxDependentIndicator
    taxFilerIndicator
    taxReturnFilingStatusType
    claimsDependentIndicator
    claimingTaxFilerNotOnApplicationIndicator
    livesWithCustodialParentNotOnApplicationIndicator
    fosterCareIndicator
    fosterCareEndAge
    medicaidDuringFosterCareIndicator
    fosterCareState
    medicaidFamilyNotProvidedIndicator
    taxFilerNotProvidedIndicator
    parentCaretakerIndicator
    pregnancyIndicator
    fullTimeStatusIndicator
    studentsParentLivingInExchangeStateIndicator
    parentLivesInStudentStateIndicator
    absentParentIndicator
    resideWithBothParentIndicator
    attestedHeadOfHouseholdIndicator
    liveApartFromSpouseIndicator
  }
  chip {
    coverageEndedIndicator
    stateHealthBenefitIndicator
    coverageEndedReasonType
    coverageEndedReasonText
  }
  insuranceCoverage {
    offeredEmployeeCoverage
    enrolledInIchraIndicator
    offeredIchraIndicator
    medicareStartDate
    hraOffers {
      hraType
      startDate
      noticeDate
      endDate
      enrolledInOfferFromSameEmployerIndicator
      enrolledInOfferFromSameEmployerUntilStartDateIndicator
      primaryInsuredMemberIdentifier
      employeeSelfOnlyOfferAmount
      employeeSelfOnlyOfferFrequencyType
      primaryInsuredMemberNotInTaxHhIndicator
      employer {
        name
        employerIdentificationNumber
        streetName1
        streetName2
        cityName
        stateCode
        zipCode
        plus4Code
        countryCode
        countyName
        countyFipsCode
      }
    }
    enrolledCoverages {
      insurancePolicyMemberId
      insurancePolicyNumber
      insurancePlanName
      insuranceMarketType
    }
    employerSponsoredCoverageOffers {
      cobraAvailableIndicator
      employeeWillDropCoverageDate
      lcsopPremiumWillChangeDate
      employeeCouldStartCoverageDate
      doNotKnowLcsopPremiumIndicator
      employeeWillDropCoverageIndicator
      lcsopPremium
      lcsopPremiumFrequencyType
      lcsopName
      employerOffersMinValuePlan
      familyPlanPremiumAmount
      familyPlanPremiumFrequencyType
      employerOffersFamilyMinValuePlanIndicator
      planToEnrollEscIndicator
      planToEnrollEscDate
      employer {
        name
        employerIdentificationNumber
        streetName1
        streetName2
        cityName
        stateCode
        zipCode
        plus4Code
        countryCode
        countyName
        countyFipsCode
      }
      employerWillChangeLcsopPremiumIndicator
      employerWillNoLongerOfferLcsopIndicator
      employerWillStopProvidingCoverageDate
      employeeStatus
      escEnrolledIndicator
      newEmployeeLcsopPremiumAmount
      newLcsopPremiumFrequencyType
      retireePlanCoverageIndicator
      waitingPeriodIndicator
      primaryInsuredMemberIdentifier
      insurancePolicyMemberId
      insurancePolicyNumber
      insurancePlanName
    }
  }
`;

export default MEMBER_ATTESTATIONS_FULL_QUERY;
